import { Box, Paper, Typography, styled } from "@mui/material"
import Button from "components/ui/Submit"

export const Container = styled(Box)(({ theme }) => ({
  margin: "21px auto",
  [theme.breakpoints.up("sm")]: {
    minWidth: "530px",
    maxWidth: "530px",
  },
}))

export const Card = styled(Paper)(({ theme }) => ({
  background: theme.palette.background.default,
  borderRadius: "17px",
  marginBottom: "38px",
  padding: "41px",
  [theme.breakpoints.down("md")]: {
    padding: "41px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "21px",
  },
}))

export const Headline = styled(Typography)(({ theme }) => ({
  fontSize: "1.125rem",
  fontWeight: "500",
  marginBottom: "41px",
  [theme.breakpoints.down("lg")]: {
    fontSize: "1rem",
    marginBottom: "21px",
  },
}))

export const Submit = styled(Button)(({ theme }) => ({
  borderRadius: "21px",
  display: "block",
  margin: "0 auto",
  width: "186px",
  [theme.breakpoints.up("lg")]: {
    bottom: "41px",
    left: "50%",
    position: "absolute",
    transform: "translate(-50%, -50%)",
  },
  [theme.breakpoints.down("lg")]: {
    position: "relative",
  },
}))
